package org.matthewo.recharts.type

object VerticalAlign {

    val top: VerticalAlign
        get() = "top".unsafeCast<VerticalAlign>()

    val middle: VerticalAlign
        get() = "middle".unsafeCast<VerticalAlign>()

    val bottom: VerticalAlign
        get() = "bottom".unsafeCast<VerticalAlign>()
}
